import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {ApiService} from "./api.service";

declare var wx : any;
declare var jquery:any;
declare var $ :any;

@Component({
    selector: 'app-practice-report',
    templateUrl: './practice-report.component.html',
    styleUrls: ['./practice-report.component.css']
})
export class PracticeReportComponent implements OnInit {
    report: any;
    sub: any;
    page: string;
    practiceId: number;
    practiceMetaId: number;
    reportType: string;
    caseId: number;
    firstEntry: number;
    currentReportIndex: number;
    isFirst:boolean;
    isSeperateModel: number;
    learningPathId:number;


    constructor(private route: ActivatedRoute,
                private router: Router,
                private  apiService: ApiService) { }

    ngOnInit() {
        this.isSeperateModel = 0;
        this.sub = this.route.params.subscribe(params => {
            this.practiceId = params['practiceId'];
            this.reportType = params['reportType'];
            this.caseId = params['caseId'];
            this.isSeperateModel = params['isSeperateModel'];
            this.firstEntry = params['firstEntry'];
            this.learningPathId = params['learningPathId'];

            this.getReport();
            if (this.reportType == "exercise") {
                this.page = "bigReport";
            }
            else {
                this.page = "smallReport";
            }
        });

    }

    getReport() {
        this.apiService.getPracticeReport("" + this.practiceId + "").subscribe(report => {
            this.report = report;
            this.practiceMetaId = report.practiceMetaId;
            if (this.caseId <= 0) {
                this.currentReportIndex = 0;
            }
            else {
                for (var i = 0; i < report.reports.length; i++) {
                    if (report.reports[i].id == this.caseId
                        && report.reports[i].type == this.reportType) {
                        this.currentReportIndex = i;
                        break;
                    }
                }
            }
        });

        /*this.report=this.getMockReport();
        this.currentReportIndex = 3;*/
    }

    startNextCase() {
        this.apiService.startNextCase("" + this.practiceId + "").subscribe(result => {
            if (result.learningPathId > 0) {
                let link = ['case-practice', result.learningPathId, result.practiceId];
                this.router.navigate(link);
            }
            else {
                let link = [result.practiceMetaId, 'case-practice'];
                this.router.navigate(link);
            }
        });
    }

    switchReport(param) {
        window.scrollTo(0,0);
        //document.documentElement.scrollTop = 0;
        //this.moveOut();
        this.page = param.type == "exercise" ? "bigReport" : "smallReport";
        this.currentReportIndex = param.index;
        //this.moveIn();

    }

    moveOut(){
        document.getElementById("reportWrap").style.transform="translate(7.7rem,0)";
    }

    moveIn(){
        document.getElementById("reportWrap").style.transform="translate(0,0)";
    }

    exit(param) {
        if (this.isSeperateModel == 1) {
            wx.closeWindow();
        }
        else {
            this.apiService.ajax({
                'type': 'get',
                'url':'/ddilearner/v1/getLearningPathMetaId/'+this.learningPathId
            }).subscribe(result=>{
                let link = ['learning-path',result.data];
                this.router.navigate(link);
            });
        }
    }

    getMockReport() {
        return {
            id: 1,
            reports: [{
                id: 1,
                name: "巩固练习1",
                description: "在这次的巩固练习中，我们主要练习了促进参与和达成共识这两个关键行动。",
                type: "quiz"
            }, {
                id: 2,
                name: "巩固练习2",
                description: "在这次的巩固练习中，我们主要练习了促进参与和达成共识这两个关键行动。",
                type: "quiz"
            }, {
                id: 1,
                name: "情景模拟1",
                type: "exercise",
                kas: [{
                    name: "说明讨论的目的",
                    value: "2"
                }, {
                    name: "澄清绩效",
                    value: "3"
                }, {
                    name: "表达绩效期望",
                    value: "4"
                }, {
                    name: "维持动力",
                    value: "2"
                }, {
                    name: "提供支持",
                    value: "4"
                }, {
                    name: "达成共识",
                    value: "3"
                }, {
                    name: "制定行动计划",
                    value: "1"
                }],
                totalKa: 19
            }, {
                id: 2,
                name: "情景模拟2",
                type: "exercise",
                kas: [{
                    name: "说明讨论的目的",
                    value: "3"
                }, {
                    name: "澄清绩效",
                    value: "2"
                }, {
                    name: "表达绩效期望",
                    value: "4"
                }, {
                    name: "维持动力",
                    value: "4"
                }, {
                    name: "提供支持",
                    value: "2"
                }, {
                    name: "达成共识",
                    value: "5"
                }, {
                    name: "制定行动计划",
                    value: "2"
                }],
                totalKa: 22
            }],
            totalQuizCount: 2,
            allQuizFinished: true,
            finishedQuizCount: 2,
            totalExerciseCount: 3,
            allExerciseFinished: false,
            finishedExerciseCount: 2,
            nextExerciseStartTime: "12月17日早上8点"
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/practice-report.component.ts